/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NotificationPreference from './NotificationPreference';

/**
 * The UserNotificationPreferences model module.
 * @module model/UserNotificationPreferences
 * @version 1.1.0
 */
class UserNotificationPreferences {
    /**
     * Constructs a new <code>UserNotificationPreferences</code>.
     * All notification preferences for a user across all topics
     * @alias module:model/UserNotificationPreferences
     * @param preferences {Array.<module:model/NotificationPreference>} 
     */
    constructor(preferences) { 
        
        UserNotificationPreferences.initialize(this, preferences);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, preferences) { 
        obj['preferences'] = preferences;
    }

    /**
     * Constructs a <code>UserNotificationPreferences</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserNotificationPreferences} obj Optional instance to populate.
     * @return {module:model/UserNotificationPreferences} The populated <code>UserNotificationPreferences</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserNotificationPreferences();

            if (data.hasOwnProperty('preferences')) {
                obj['preferences'] = ApiClient.convertToType(data['preferences'], [NotificationPreference]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserNotificationPreferences</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserNotificationPreferences</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UserNotificationPreferences.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        if (data['preferences']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['preferences'])) {
                throw new Error("Expected the field `preferences` to be an array in the JSON data but got " + data['preferences']);
            }
            // validate the optional field `preferences` (array)
            for (const item of data['preferences']) {
                NotificationPreference.validateJSON(item);
            };
        }

        return true;
    }


}

UserNotificationPreferences.RequiredProperties = ["preferences"];

/**
 * @member {Array.<module:model/NotificationPreference>} preferences
 */
UserNotificationPreferences.prototype['preferences'] = undefined;






export default UserNotificationPreferences;

